<template>
  <div class="step-wrapper">
    <Menu current="3" :finish="finish"></Menu>
    <div class="step-inner step_contact">
      <img src="~@static/funding_cpunk/creation/step3.png" class="bg" alt="" />
      <div class="field1">
        <input v-model.trim="name" />
      </div>
      <div class="field2">
        <input type="number" v-model.trim="telephone" />
      </div>
      <div class="field3" @click="toProfile"></div>
      <div class="create_btn_s1" @click="bindToPrevPart" :data-part="curPart"># 上一步 #</div>
      <div class="create_btn_s1 confirm" @click="bindToNextPart" :data-part="curPart"># 确认提交 #</div>
      <div style="height: 100px"></div>
    </div>
  </div>
</template>

<script>
import Menu from '../components/Menu'
import StepBtn from '../components/StepBtn'
import { mapState, mapMutations } from 'vuex'
import { verify } from '@/utils'
import { behavior } from '@/utils/behavior'

export default {
  name: '',
  components: {
    Menu,
    StepBtn,
  },
  data() {
    return {
      finish: '',
      hostUrl: this.$apiConfig.host,
      uploadUrl: this.$apiConfig.uploadUrl,
      projectCreateData: {},
      name: '',
      telephone: '',
      curPart: 1,
      supportsCustom: '',
      finish: 0,
    }
  },
  computed: {
    ...mapState(['fundingNewProjectCreate', 'nickname', 'mobile']),
  },
  mounted() {
    this.name = this.nickname
    this.telephone = this.mobile

    let { supports, name, telephone } = this.fundingNewProjectCreate

    if (typeof supports != 'undefined') {
      this.name = name
      this.telephone = telephone
    }

    this.projectCreateData = JSON.parse(JSON.stringify(this.fundingNewProjectCreate))
    this.finishedStep()
  },
  methods: {
    ...mapMutations(['setFundingNewProjectCreate']),
    bindToNextPart: function (e) {
      if (this.name == '') {
        alert('名字很重要')
        return false
      }
      if (this.telephone != '') {
        if (!verify.isPhone(this.telephone)) {
          alert('请输入正确的手机号码')
          return false
        }
      } else {
        alert('请输入正确的手机号码')
        return false
      }

      //提交preview
      let step3Data = {
        name: this.name,
        telephone: this.telephone,
        supports: '无',
        supportsCustom: '',
        step3Finish: true,
      }

      //存入storage
      this.setFundingNewProjectCreate({
        ...this.fundingNewProjectCreate,
        ...step3Data,
      })

      this.$router.replace({ path: '/fundingnew/creation/preview', query: this.$route.query })
      _jcq.push(['_track', 'yjhbcsubmission_click'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc29' })
    },
    bindToPrevPart: function (e) {
      this.$router.push({ path: `/fundingnew/creation/step2`, query: this.$route.query })
    },
    toProfile() {
      _jcq.push(['_track', 'yjhbcpersonal_click'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc30' })
      this.$router.push('/fundingnew/my/profile?profile_from=creation')
    },
    finishedStep() {
      let { step1Finish, step2Finish, step3Finish } = this.fundingNewProjectCreate

      if (typeof step3Finish != 'undefined') {
        this.finish = 3
        return
      }
      if (typeof step2Finish != 'undefined') {
        this.finish = 2
        return
      }
      if (typeof step1Finish != 'undefined') {
        this.finish = 1
        return
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.step_contact {
  position: relative;
  .bg {
    display: block;
    width: pxtow(652);
    margin: 0 auto pxtow(100);
  }

  .field1,
  .field2 {
    position: absolute;
    left: pxtow(50);
    top: pxtow(464);
    height: pxtow(60);
    line-height: pxtow(60);
    padding-left: pxtow(48);
    input {
      background-color: transparent;
      border: none;
    }
  }
  .field1 {
    top: pxtow(464);
  }
  .field2 {
    top: pxtow(618);
  }
  .field3 {
    position: absolute;
    left: pxtow(50);
    top: pxtow(780);
    height: pxtow(60);
    width: pxtow(600);
  }
  .confirm {
    margin-top: pxtow(46);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/creation/Step3.vue